import { OTHERWORLD_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/otherworldBackdrops';
import { ATMOSPHERE_PALETTE as P } from '../palette';
import { aquaticBiome } from '../biomeArchetypes';

/** Underwater (sunken ruins / reef) — teal caustic motes, blue-green shafts, a teal light bed,
 *  rising bubbles, caustic shimmer, teal fog, and a distant seabed ridge. */
export const UNDERWATER = aquaticBiome({
  id: 'underwater',
  sky: { from: 0x0e3a42, to: 0x05161c },
  motes: { colors: [P.deepTeal, P.cyan, P.mint] },
  rays: { color: P.cyan },
  glow: {
    blobs: [
      { color: P.deepTeal, atX: 0.5, atY: 0.95, size: 540, alpha: 0.1 },
      { color: P.abyssBlue, atX: 0.5, atY: 0.05, size: 600, alpha: 0.1 },
    ],
    breathe: { periodMs: 7000, min: 0.75, max: 1.25 },
  },
  lightField: { palette: [P.deepTeal, P.cyan, P.mint] },
  weather: { mode: 'rise', color: 0xbfeaff, size: 16, frequencyMs: 200, lifespanMs: 5000, speed: 22, windX: 14, alphaEnd: 0.4, gust: { periodMs: 8000, min: 0.55, max: 1.45, phase: 0.3 } },
  flicker: { color: P.cyan },
  extraLayers: [
    { kind: 'caustics', color: 0x9beaff, count: 7, sizeMin: 240, sizeMax: 480, alphaMin: 0.08, alphaMax: 0.28, bandYMin: 0.5, bandYMax: 0.9, driftPx: 46, periodMinMs: 3500, periodMaxMs: 7000 },
  ],
  fog: { color: P.deepTeal, bands: 5, alphaMin: 0.05, alphaMax: 0.16, driftPx: 60, periodMinMs: 13000, periodMaxMs: 22000 },
  postFogLayers: [
    { kind: 'critters', count: 7, palette: [P.cyan, P.deepTeal, P.mint], sizeMin: 6, sizeMax: 12, speedMin: 16, speedMax: 30, bandYMin: 0.35, bandYMax: 0.62, direction: 'both' },
  ],
  parallax: [
    { svg: OTHERWORLD_BACKDROPS.ruins.far, shape: 'ridge', color: 0x166068, speed: 0.04, height: 360, alpha: 0.62, detail: 0.8, sway: { ampPx: 16, periodMs: 24000 } },
    { svg: OTHERWORLD_BACKDROPS.ruins.mid, shape: 'dunes', color: 0x0e3e46, speed: 0.10, height: 250, alpha: 0.8, detail: 1 },
    { svg: OTHERWORLD_BACKDROPS.ruins.near, shape: 'ridge', color: 0x08272e, speed: 0.16, height: 170, alpha: 0.92, detail: 1 },
  ],
  closer: { grade: { top: 0x49c9c0, bottom: 0x123a55, strength: 0.15 } },
});
